export const WHOLESALE_PRODUCT_IDS = [
  8143851618473,
  8290860761257,
  7785338470569,
  8175055700137,
  8234992631977,
  7785340076201,
  8301058261161
];
